import { config } from '../configuration/config';

export const BASE_PATH = '#/intro';
export const STORE_BASE_PATH = 'routeWidget/';
export const DEFAULT_ROUTE = '/';
export const SUMMARY_ROUTE = '/route-summary';
export const VEHICLE_ROUTE = '/vehicle-options';
export const TOUR_HANDLING_ROUTE = '/tour-handling';
export const TOUR_HANDLING_DETAILS = '/tour-handling/details';
export const TOUR_SETTINGS_ROUTE = '/tour-options';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const ZOOM_CENTER = 18;
export const WINDOW_BOUNDING_BOX_DEGREES = 0.2;
export const MAX_AUTO_SUGGEST_ITEMS = 5;
export const MAX_AUTO_SUGGEST_RADIUS = 50000; // in meters
export const POWER_LOW = 150; // in kW
export const POWER_MEDIUM = 350; // in kW
export const POWER_HIGH = 750; // in kW
export const FEATURE_TOGGLES_POLLING_FREQ = 60; // in seconds
export const DEFAULT_TIME_AT_STOPOVER = '00:30'; // in min
export const DEFAULT_VEHICLE_PROFILE = 'man-etgx-4x2-tractor-semitrailer';
export const ASSET_TAB_SUMMARY = 'SUMMARY';
export const ASSET_TAB_HISTORY = 'HISTORY';
export const ASSET_TAB_ACTIVITY = 'ACTIVITY';
export const ASSET_TAB_TOURS = 'TOURS';
export const ASSET_TAB_REMOTE_DOWNLOAD = 'REMOTE_DOWNLOAD';
export const ASSET_TAB_NOTIFICATIONS = 'NOTIFICATIONS';
export const ASSET_TAB_UNIT = 'UNIT';
export const ASSET_TAB_RANGE = 'RANGE';
export const ASSET_TAB_CHAT = 'CHAT';

export const Unit = {
    KWH: 'kWh',
    kW: 'kW',
    currency: '€',
    weight: 'kg',
    tons: 't',
    km: 'km',
    meters: 'm',
    pct: '%',
    temperature: 'ºC',
};

export const MarketplaceSettings = {
    MARKETPLACE_URL: config.backend.MARKETPLACE_SERVICE,
    UPSELLING_URL: config.backend.MARKETPLACE_UPSELLING_SERVICE,
    BUY_BUTTON_URL: config.backend.MARKETPLACE_BUY_BUTTON_SERVICE,
    productId: 'man-sku00000085',
    defaultLevel: '15',
    internalCampaign: 'livemonitor-route-widget-man-smart-route-upselling',
};

export const API = {
    serviceName: 'smart-route-web-api',
    version: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
    },
    endpoints: {
        vehicles: '/vehicles',
        accountSubscription: '/account/subscription',
        assetSubscription: '/subscription/asset',
        chargeStationOperators: '/operators',
        featureToggles: '/feature-toggles',
        isoline: '/isoline',
        itineraries: '/itineraries',
        route: '/route',
        tour: '/tour',
        vehicleProfiles: '/profiles',
        sendToVehicle: '/send-to-vehicle',
        sendToOptimizer: '/send-to-optimizer',
        chargingStations: '/charging-stations',
        metadata: '/metadata',
        locationSearch: '/locations/search',
        locationReverse: '/locations/reverse',
    },
    parameters: {
        limit: 1000,
    },
};

export const BASE_URL_V2 = `${config.backend.BACKEND_DOMAIN}/${API.serviceName}/${API.version.v2}`;
export const BASE_URL_V3 = `${config.backend.BACKEND_DOMAIN}/${API.serviceName}/${API.version.v3}`;
